<template>
  <div class="fuhe">
    <div class="section1">
      <div class="left">
        <div class="title">项目总负荷</div>
        <div class="chart-box">
          <v-chart :option="option" ref="chart"></v-chart>
        </div>
      </div>
      <div class="right">
        <div class="item" v-for="(item, index) in kwList" :key="index">
          <p>{{ item.key }}</p>
          <p>{{ item.value }}</p>
        </div>
      </div>
    </div>
    <div class="section2">
      <div class="item1">
        <div class="left common">
          <div class="title">变压器负荷（kW）</div>
          <div class="table-box">
            <el-table :data="tableData" style="width: 100%" height="320" @row-click="getHuilu"
              :row-class-name="tableRowClassName">
              <!-- <el-table-column prop="number" label="编号"> </el-table-column> -->
              <el-table-column align="center" type="index" label="序号">
              </el-table-column>
              <el-table-column prop="equipmentDesc" label="变压器" width="120">
              </el-table-column>
              <el-table-column prop="todayLoad" label="今日"> </el-table-column>
              <el-table-column prop="highestLoad" label="历史最高">
              </el-table-column>
              <el-table-column prop="go" label="" width="30">
                <template slot-scope="scope">
                  {{ scope.$index == tableIndex ? ">" : "" }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="right common">
          <div class="title">高负荷回路关注列表</div>
          <div class="table-box">
            <el-table :data="tableData2" style="width: 100%" height="320">
              <el-table-column prop="number" label="编号"> </el-table-column>
              <el-table-column prop="equipmentDesc" label="开关" width="120">
              </el-table-column>
              <el-table-column prop="todayLoad" label="今日"> </el-table-column>
              <el-table-column prop="highestLoad" label="历史最高">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="item1 item2">
        <div class="left common">
          <div class="title">高负荷回路（kW）</div>
          <div class="table-box">
            <el-table :data="tableData3" style="width: 100%" height="320">
              <el-table-column prop="number" label="编号"> </el-table-column>
              <el-table-column prop="equipmentDesc" label="回路" width="120">
              </el-table-column>
              <el-table-column prop="todayLoad" label="今日"> </el-table-column>
              <el-table-column prop="highestLoad" label="历史最高">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ECharts from "vue-echarts";
  export default {
    components: { "v-chart": ECharts },
    data () {
      return {
        projectId: -1,
        option: {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          legend: {
            right: "5%",
            top: "4%",
            data: ["今日有功功率", "上周同期"],
          },
          color: [
            "rgba(0, 191, 113, 1)",
            "rgba(251, 199, 2, 1)",
            "rgba(20, 108, 224, 1)",
          ],
          grid: {
            left: "1%",
            right: "4%",
            bottom: "3%",
            top: "15%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            axisLabel: {
              color: "rgba(158, 158, 168, 1)",
              fontSize: 14,
            },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
            data: [
              "0时",
              "1时",
              "2时",
              "3时",
              "4时",
              "5时",
              "6时",
              "7时",
              "8时",
              "9时",
              "10时",
              "11时",
              "12时",
              "13时",
              "14时",
              "15时",
              "16时",
              "17时",
              "18时",
              "19时",
              "20时",
              "21时",
              "22时",
              "23时",
            ],
          },
          yAxis: {
            type: "value",
            axisLabel: {
              color: "rgba(158, 158, 168, 1)",
              fontSize: 14,
            },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#E8E8E8",
              },
            },
          },
          series: [
            {
              name: "今日有功功率",
              type: "line",
              symbolSize: 0,
              lineStyle: {
                width: 4,
              },
              data: [],
            },
            {
              name: "上周同期",
              type: "line",
              symbolSize: 0,
              lineStyle: {
                width: 4,
              },
              data: [],
            },
          ],
        },
        kwList: [
          {
            key: "当日最大值",
            value: "暂无",
          },
          {
            key: "当日最小值",
            value: "暂无",
          },
          {
            key: "当日平均值",
            value: "暂无",
          },
          {
            key: "负载率",
            value: "5.1%",
          },
          {
            key: "峰谷差率",
            value: "64.2%",
          },
        ],
        tableData: [],
        tableData2: [],
        tableData3: [],
        tableIndex: 0,
        topicList: [],
      };
    },
    created () {
      this.projectId = this.$getCookie("projectId");
      this.searchProjectActivePower();
      this.searchLoadByType();
      this.searchLoadByRanking();
      console.log(
        "this.$dateForma ",
        this.$dateFormat("HH", new Date("2021-01-24 16:45:27"))
      );
    },
    methods: {
      tableRowClassName ({ row, rowIndex }) {
        if (rowIndex === this.tableIndex) {
          return "active";
        }
        return "";
      },
      // 上折线图和列表
      searchProjectActivePower () {
        this.$http
          .post("bma-distribution-service/realTime/searchProjectActivePower", {
            projectId: this.projectId,
          })
          .then((res) => {
            console.log("res: ", res);
            // 列表
            this.kwList[0].value = this.$getTwo(res.data.todayMax) + "kW";
            this.kwList[1].value = this.$getTwo(res.data.toadyMin) + "kW";
            this.kwList[2].value = this.$getTwo(res.data.todayAvg) + "kW";
            // this.kwList[2].value=res.data.todayAvg + "kW";
            this.kwList[3].value =
              res.data.projectLoadRate === "-"
                ? "-"
                : this.$getFour(res.data.projectLoadRate * 100) + "%";
            this.kwList[4].value =
              res.data.peakGrainDiff === "-"
                ? "-"
                : this.$genderMenu(res.data.peakGrainDiff * 100) + "%";
            // 折线图
            let todayActivePower = res.data.todayActivePower;
            let lastWeekActivePower = res.data.lastWeekActivePower;
            let todayArr = [];
            let lastWeekArr = [];
            todayActivePower.forEach((item) => {
              // todayArr.push(this.$getTwo(Number(item.date)));
              todayArr.push(Number(item.date.substring(8)));
            });
            lastWeekActivePower.forEach((item) => {
              lastWeekArr.push(Number(item.date.substring(8)));
            });
            let todyData = [];
            let lastWeekData = [];
            for (let i = 0; i <= 23; i++) {
              let index1 = todayArr.indexOf(i);
              let index2 = lastWeekArr.indexOf(i);
              if (index1 > -1) {
                todyData.push(this.$getTwo(todayActivePower[index1].activePower));
              } else if (index1 == -1 && i <= new Date().getHours()) {
                todyData.push(0);
              } else {
                todyData.push("");
              }
              if (index2 > -1) {
                lastWeekData.push(
                  this.$getTwo(lastWeekActivePower[index2].activePower)
                );
              } else {
                lastWeekData.push(0);
              }
            }
            this.option.series[0].data = todyData;
            this.option.series[1].data = lastWeekData;
            this.$refs.chart.setOption(this.option, true);

            // this.setStomp(res.data);
          });
      },
      setStomp (data) {
        const _this = this;
        if (data) {
          data.subscribeFields.forEach((item) => {
            if (this.topicList.indexOf(item.subscribeField) == -1) {
              this.topicList.push(item.subscribeField);
            }
            this.$timeing(item.subscribeField, item.subscribeField, (res) => {
              let data = JSON.parse(res.body);
              if (data.field.indexOf("todayMax") > -1) {
                this.kwList[0].value = this.$getTwo(data.value) + "kW";
              } else if (data.field.indexOf("toadyMin") > -1) {
                this.kwList[1].value = this.$getTwo(data.value) + "kW";
              } else if (data.field.indexOf("todayAvg") > -1) {
                this.kwList[2].value = this.$getTwo(data.value) + "kW";
                // this.kwList[2].value = data.value + "kW";
              } else if (data.field.indexOf("projectLoadRate") > -1) {
                this.kwList[3].value = this.$getFour(data.value * 100) + "%";
              } else if (data.field.indexOf("peakGrainDiff") > -1) {
                this.kwList[4].value = this.$getTwo(data.value * 100) + "%";
              } else if (data.field.indexOf("todayActivePower") > -1) {
                let index = this.$dateFormat("HH", new Date(data.time));
                this.option.series[0].data[index] = data.value;
                console.log(
                  "------------------------" +
                  JSON.stringify(this.option.series[0].data)
                );
                this.$refs.chart.setOption(this.option, true);
              } else if (data.field.indexOf("lastWeekActivePower") > -1) {
                let index = this.$dateFormat("HH", new Date(data.time));
                this.option.series[1].data[index] = data.value;
                this.$refs.chart.setOption(this.option, true);
              }
              console.log(this.kwList);
            });
          });
        }
      },
      getHuilu (e) {
        this.tableIndex = e.number - 1;
        this.searchLoadByType2(e.equipmentId);
      },
      // 底部第一个表格
      searchLoadByType () {
        this.$http
          .post("bma-distribution-service/loadAnalysis/searchLoadByType", {
            projectId: this.projectId,
            equipmentTypeId: 2,
          })
          .then((res) => {
            if (res.data) {
              res.data.forEach((item, index) => {
                item.number = index + 1;
                item.todayLoad = this.$getTwo(item.todayLoad);
                item.highestLoad = this.$getTwo(item.highestLoad);
                item.go = ">";
              });
            }
            this.tableData = res.data;
            console.log("this.tableData: ", this.tableData);
            if (res.data.length > 0) {
              this.searchLoadByType2(res.data[0].equipmentId);
            }
          });
      },
      // 底部第二个表格
      searchLoadByType2 (id) {
        this.$http
          .post("bma-distribution-service/loadAnalysis/searchLoadByType", {
            projectId: this.projectId,
            equipmentTypeId: 4,
            parentId: id,
          })
          .then((res) => {
            if (res.data) {
              res.data.forEach((item, index) => {
                item.number = index + 1;
                item.todayLoad = this.$getTwo(item.todayLoad);
                item.highestLoad = this.$getTwo(item.highestLoad);
              });
            }
            this.tableData2 = res.data;
          });
      },
      // 底部第三个表格
      searchLoadByRanking (id) {
        this.$http
          .post("bma-distribution-service/loadAnalysis/searchLoadByRanking", {
            projectId: this.projectId,
            equipmentTypeId: 4,
          })
          .then((res) => {
            if (res.data) {
              res.data.forEach((item, index) => {
                item.number = index + 1;
                item.todayLoad = this.$getTwo(item.todayLoad);
                item.highestLoad = this.$getTwo(item.highestLoad);
              });
            }
            this.tableData3 = res.data;
          });
      },
    },
    beforeDestroy () {
      this.topicList.forEach((item) => {
        this.$clearTimeing(item);
      });
    },
  };
</script>
<style lang="less" scoped>
  /deep/.el-table {
    background: rgba(0, 0, 0, 0);

    .active {
      background: #f1f3f6;

      td {
        &:first-of-type {
          border-left: 2px solid rgba(52, 128, 255, 1);
        }
      }
    }

    .el-table__row {
      cursor: pointer;
    }

    th,
    tr {
      background: rgba(0, 0, 0, 0);
    }

    thead {
      background: #f5f5f5 !important;
    }

    th {
      >.cell {
        color: #152139;
        font-size: 14px;
        font-weight: 600;
        text-align: center;
      }
    }

    tr {
      td {
        text-align: center;
        font-size: 14px;
        color: #152139;
      }
    }

    .data-info {
      display: flex;
      justify-content: space-around;

      .item {
        span {
          color: #152139;

          &:last-of-type {
            font-weight: 600;
          }
        }
      }
    }
  }

  .fuhe {
    padding: 15px;
    background: #ececec;

    .section1 {
      width: 100%;
      height: 620px;
      background: #f8f8f9;
      box-shadow: 0px 0px 13px rgba(32, 47, 79, 0.09);
      border-radius: 7px;
      padding: 20px;
      box-sizing: border-box;
      display: flex;

      .left {
        width: 75%;
        height: 100%;

        .title {
          font-size: 22px;
          color: #293e69;
          font-weight: 600;
          text-align: left;
          text-indent: 10px;
        }

        .chart-box {
          width: 100%;
          height: 550px;
        }
      }

      .right {
        padding-top: 30px;
        width: 25%;

        .item {
          width: 100%;
          height: 90px;
          border: 1px solid #eaeaea;
          border-radius: 9px;
          display: flex;
          justify-content: space-around;
          margin-bottom: 16px;

          p {
            width: 50%;
            text-align: left;
            line-height: 90px;
            color: #293e69;
            font-size: 18px;
            text-align: center;

            &:last-of-type {
              color: #0e223d;
              background: rgba(234, 234, 234, 0.5);
            }
          }
        }
      }
    }

    .section2 {
      width: 100%;
      margin-top: 15px;
      display: flex;
      justify-content: space-between;

      .item1 {
        width: 66%;
        height: 446px;
        padding: 25px;
        box-sizing: border-box;
        background: #f8f8f9;
        box-shadow: 0px 0px 13px rgba(32, 47, 79, 0.09);
        display: flex;
        justify-content: space-between;

        .common {
          .title {
            font-size: 18px;
            color: #181d33;
            font-weight: 600;
            padding-bottom: 25px;
            border-bottom: 1px solid #eeeeef;
            text-align: left;
          }
        }

        .left {
          width: 530px;
        }

        .right {
          width: 500px;
        }
      }

      .item2 {
        width: 33%;
        height: 446px;
        padding: 25px;
        box-sizing: border-box;
        background: #f8f8f9;
        box-shadow: 0px 0px 13px rgba(32, 47, 79, 0.09);
      }
    }
  }
</style>